module.exports = __webpack_public_path__ + "static/img/mp1.ca491a2e.jpg";